export default {
  name: "Real-Time Voice Coach",
  technologies:
    "Pipecat, Deepgram, ElevenLabs, Langfuse, Python, FastAPI, PydanticAI, React + Vite (TypeScript), PostgreSQL, Cloudflare TURN",
  bullets: [
    "Built a real-time voice coach enabling role play, reflection, and preparation exercises to improve communication.",
  ],
};
